import { Logout, FetchMCOnboardingsCounts } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { MCOnboardingState } from './types'

const getInitialState = (): MCOnboardingState => ({
  mcOnboardingCounts: null,
})

export const mcOnboardingReducer = (
  state: MCOnboardingState = getInitialState(),
  action: Action<any>,
): MCOnboardingState => {
  switch (action.type) {
    case FetchMCOnboardingsCounts.type.SUCCESS:
      return {
        ...state,
        mcOnboardingCounts: action.payload,
      }
    case Logout.type.SUCCESS:
      return getInitialState()
    default:
      return state
  }
}
